import { getObjectId, isTicketClosed } from 'conversations-thread-data/tickets/public/operators';
import { Fragment } from 'react';
import { getIsClosed, getIsFiltered, getIsOpen, getIsSoftDeleted } from 'conversations-thread-data/thread-details/public/operators';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import TicketStatusLabel from 'conversations-thread-view/thread-toolbar/components/TicketStatusLabel';
// @ts-expect-error type not available yet
import ThreadDeleteButton from 'conversations-thread-view/thread-deletion/components/ThreadDeleteButton';
import TicketStageDropdown from 'svh-workspace-ui-lib/ticket-header/public/TicketStageDropdown';
// @ts-expect-error type not available yet
import { ticketStageUpdated } from 'conversations-thread-view/thread-toolbar/actions/ticketStageUpdated';
import TicketOutOfSyncTooltip from './TicketOutOfSyncTooltip';
import { useTicketPipelines } from 'conversations-thread-data/tickets/public/hooks';
import { useUpdateTicketProperties } from 'conversations-inbox-lib/tickets/mutations/useUpdateTicketProperties';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { isUngatedToTicketStatusConditionalProperties } from '../../selectors/gateSelectors';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TicketPrimaryActions = ({
  ticketStages,
  isThreadStatusChangeInProgress,
  threadDetails,
  ticket,
  disabled,
  openDeletePrompt,
  ticketExists
}) => {
  const {
    pipelines: ticketPipelines
  } = useTicketPipelines();
  const {
    updateTicketProperties
  } = useUpdateTicketProperties({
    ticketId: ticket && ticket.id
  });
  const ungatedToTicketStatusConditionalProperties = useSelector(isUngatedToTicketStatusConditionalProperties);
  const closeable = getIsOpen(threadDetails);
  const openConversationWithTicketIsOutOfSync = closeable && ticket && isTicketClosed(ticket) && !isThreadStatusChangeInProgress;
  const closedConversationWithTicketIsOutOfSync = !closeable && ticket && !isTicketClosed(ticket) && !isThreadStatusChangeInProgress;
  const ticketAndConversationIsInSync = !openConversationWithTicketIsOutOfSync && !closedConversationWithTicketIsOutOfSync;
  const ticketDataLoaded = ticket && getObjectId(ticket) && ticketPipelines && ticketStages;
  const ticketIsLoading = ticketExists && !ticketDataLoaded;
  const renderTicketStageDropdown = () => {
    return /*#__PURE__*/_jsx(TicketStageDropdown, {
      ticket: ticket,
      ticketPipelines: ticketPipelines,
      ticketStages: ticketStages,
      updateTicketProperties: updateTicketProperties,
      ticketStageUpdated: ticketStageUpdated,
      trackEvent: trackEvent,
      ungatedToTicketStatusConditionalProperties: ungatedToTicketStatusConditionalProperties
    });
  };
  if (ticket && ticket.userPermissions && !ticket.userPermissions.currentUserCanView) {
    return null;
  }
  if (ticketIsLoading) {
    return /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(TicketStatusLabel, {}),
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        size: "small"
      })
    });
  }
  if (ticket) {
    if (ticketDataLoaded && !getIsSoftDeleted(threadDetails) && ticketAndConversationIsInSync) {
      return renderTicketStageDropdown();
    }
    if (getIsClosed(threadDetails)) {
      return /*#__PURE__*/_jsx(Fragment, {
        children: /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(TicketOutOfSyncTooltip, {
            isOpenConversation: false
          }), renderTicketStageDropdown()]
        })
      });
    } else if (closeable) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(TicketOutOfSyncTooltip, {
            isOpenConversation: true
          }), renderTicketStageDropdown()]
        }), getIsFiltered(threadDetails) && /*#__PURE__*/_jsx(ThreadDeleteButton, {
          onClick: openDeletePrompt,
          disabled: disabled
        })]
      });
    }
  }
  return null;
};
TicketPrimaryActions.displayName = 'TicketPrimaryActions';
export default TicketPrimaryActions;